import { Tab } from '@features/admin/distribution-evaluation/constants';
import { IDistributionEvaluation } from '@features/admin/distribution-evaluation/interfaces';
import { createSlice } from '@reduxjs/toolkit';
import { REPORT_PAGE_LIMIT, DEFAULT_REPORT_PAGE } from '../../common/constants';

interface IState {
  tabName: Tab;
  filters: IDistributionEvaluation;
  isEvaluationBack: boolean;
}

const initialState: IState = {
  tabName: Tab.Distribution,
  filters: {
    school: null,
    classes: null,
    module: null,
    from_date: null,
    to_date: null,
    status: null,
    page_size: REPORT_PAGE_LIMIT,
    page: DEFAULT_REPORT_PAGE,
  },
  isEvaluationBack: false,
};
const distributionEvaluationSlice = createSlice({
  name: 'distributionEvaluation',
  initialState,
  reducers: {
    setTabName: (state, action) => {
      state.tabName = action.payload;
    },
    setDistributionEvaluationFilters: (state, action) => {
      state.filters = action.payload;
    },
    setIsEvaluationBack: (state, action) => {
      state.isEvaluationBack = action.payload;
    },
  },
});

export const {
  setDistributionEvaluationFilters,
  setTabName,
  setIsEvaluationBack,
} = distributionEvaluationSlice.actions;

export default distributionEvaluationSlice.reducer;
